import React, { useState } from 'react';
import styles from './SystemDetails.module.css';
import SensorToGraphPicker from '../SharedGraphs/SensorToGraphPicker';
import ListPicker from '../Shared/ListPicker';
import SensorsGraph from '../SharedGraphs/SensorsGraph';
import { TIME_PRESETS } from '../../config';

function SensorsGraphWithOptions({
  sensors,
  systemId,
  height,
  showDots,
  title,
  yMin = 'dataMin',
  yMax = 'dataMax'
}) {
  const [sensorToGraph, setSensorToGraph] = useState(sensors[0]);
  const [selectedPreset, setSelectedPreset] = useState(TIME_PRESETS.hour);

  const timePresets = [
    TIME_PRESETS.hour,
    TIME_PRESETS.twelveHours,
    TIME_PRESETS.twentyFourHours,
    TIME_PRESETS.fortyEightHours
  ];

  const today = new Date();
  const fromDate = new Date();
  fromDate.setHours(fromDate.getHours() - selectedPreset.number);

  return (
    <div>
      <p className={styles.sensorExplainerText}>{title}</p>
      <div className={styles.sensorToGraphOptionsContainer}>
        <SensorToGraphPicker
          sensors={sensors}
          onSensorClicked={(value) => setSensorToGraph(value)}
          selectedSensor={sensorToGraph}
        />
        <ListPicker
          options={timePresets.map((preset) => preset.name)}
          selected={selectedPreset.name}
          setSelected={(name) =>
            setSelectedPreset(
              timePresets.find((preset) => preset.name === name)
            )
          }
        />
      </div>
      <SensorsGraph
        showDots={showDots}
        sensors={sensors}
        systemId={systemId}
        height={height}
        timePreset={selectedPreset}
        toDate={today}
        fromDate={fromDate}
        sensorToGraph={sensorToGraph}
        yMax={yMax}
        yMin={yMin}
      />
    </div>
  );
}

export default SensorsGraphWithOptions;
